import { skipToken, useQuery } from '@tanstack/react-query';
import { createRetryFn } from '../config/react-query';
import useApiManager from './useApiManager';

const MAX_RETRIES = 3;

// The meeting does not start until this query settles, so the retry delays must add up to less than 5 seconds.
const RETRY_DELAY_MS = 1_500;

/**
 * Fetches public schedule information for a meeting room via the schedule-info endpoint.
 */
export function useScheduleInfo(meetingId: string | null) {
  const apiManager = useApiManager();

  return useQuery({
    queryKey: ['schedule-info', meetingId],
    queryFn: meetingId ? () => apiManager.ownership.getScheduleInfo(meetingId) : skipToken,
    staleTime: 60_000,
    retry: createRetryFn({ maxRetries: MAX_RETRIES }),
    retryDelay: RETRY_DELAY_MS,
    refetchOnWindowFocus: false,
  });
}
